import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/chiguaData';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleAnchor = (id: string) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? 'bg-background-50/90 backdrop-blur-md border-b border-background-200'
          : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between px-4 md:px-6 h-16 md:h-[72px]">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          className="flex items-center gap-2 group cursor-pointer"
        >
          <span
            className={`w-9 h-9 md:w-10 md:h-10 rounded-xl flex items-center justify-center transition-colors ${
              scrolled ? 'bg-primary-500 text-background-50' : 'bg-background-50/90 text-primary-600'
            }`}
          >
            <i className="ri-leaf-line text-lg md:text-xl"></i>
          </span>
          <span
            className={`font-heading text-lg md:text-xl font-bold tracking-wide ${
              scrolled ? 'text-foreground-950' : 'text-background-50'
            }`}
          >
            吃瓜<span className="text-primary-500">网站</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((l) => (
            <button
              key={l.id}
              onClick={() => handleAnchor(l.id)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                  : 'text-background-100 hover:bg-background-50/15 hover:text-background-50'
              }`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#entrance"
            onClick={(e) => {
              e.preventDefault();
              handleAnchor('entrance');
            }}
            className={`hidden sm:inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer ${
              scrolled
                ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                : 'bg-background-50/95 text-primary-600 hover:bg-background-50'
            }`}
          >
            <i className="ri-arrow-right-up-line text-base"></i>
            进入入口
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            aria-label="菜单"
            className={`md:hidden w-10 h-10 rounded-lg flex items-center justify-center cursor-pointer transition-colors ${
              scrolled ? 'text-foreground-950 hover:bg-background-100' : 'text-background-50 hover:bg-background-50/15'
            }`}
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {open && (
        <nav className="md:hidden px-4 pb-5 pt-1 bg-background-50/95 backdrop-blur-md">
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <button
                key={l.id}
                onClick={() => handleAnchor(l.id)}
                className="text-left px-3 py-3 rounded-lg text-foreground-800 hover:bg-primary-50 hover:text-primary-700 cursor-pointer"
              >
                {l.label}
              </button>
            ))}
            <a
              href="#entrance"
              onClick={(e) => {
                e.preventDefault();
                handleAnchor('entrance');
              }}
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 text-background-50 px-5 py-3 text-sm font-semibold cursor-pointer"
            >
              <i className="ri-arrow-right-up-line text-base"></i>进入入口
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}